var _objectSpread = require("/home/circleci/project/packages/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");

function normalizeHex(hex, opts) {
  opts = _objectSpread({
    evenLength: false,
    addPrefix: false
  }, opts);
  var value = '';

  if (Buffer.isBuffer(hex)) {
    hex = hex.toString('hex');
  }

  if (typeof hex === 'number') {
    hex = hex.toString();
  }

  if (typeof hex === 'string') {
    value = hex.toLowerCase();
  }

  if (value.startsWith('0x')) {
    value = value.slice(2);
  }

  var data = value.length % 2 ? "0".concat(value) : value;

  if (Buffer.from(data, 'hex')) {
    value = opts.evenLength ? data : value;
  }

  if (opts.addPrefix) {
    value = "0x".concat(value);
  }

  return value;
}

module.exports = normalizeHex;